module.exports = __webpack_public_path__ + "assets/img/deadpool.cc16f89b60bd8e438fec3fd22d41a4fc.svg";